// supportTeamIdentity — identidad visual del equipo de soporte (Reemplazo de Intercom, Fase 3).
//
// Los mensajes del equipo (ADMIN) llegan con un author_name plano (ej. "Fede Serbin").
// Este módulo deriva de ese nombre:
//   - avatarFor(authorName, {team}) → datos para pintar el avatar (la foto del equipo si la hay,
//     o iniciales sobre círculo).
//   - displayNameFor(authorName) → "{PrimerNombre} · Dashbo" para el header de la burbuja.
import fedePhoto from '../../images/team/fede.jpg';

// Mapa primer nombre → foto del equipo. La de fede es la de su perfil de Google en Dashbo
// (`User.profile_picture_url` de fede@dashbo.io, bajada al repo el 02/10/2026): la foto real del
// mensaje (`author_avatar_url`) le gana igual donde llega, pero el saludo del panel no tiene mensaje
// del que sacarla.
export const TEAM_AVATAR_ASSETS = {
    'Fede': fedePhoto,
};

// Quién pone la cara en el saludo del panel: UNA foto, la de fede (D10 del recorrido de la 2.1). El
// texto del saludo habla del «equipo de Dashbo»; la foto es la persona que contesta.
export const GREETING_TEAM_MEMBER = 'Fede';

// Primer nombre "presentable" del author_name (primer token no vacío).
export function firstNameOf(authorName) {
    const name = (authorName || '').trim();
    if (!name) return '';
    return name.split(/\s+/)[0];
}

// Iniciales (1 o 2 letras) para el fallback del avatar.
export function initialsOf(authorName) {
    const name = (authorName || '').trim();
    if (!name) return '?';
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

// Datos para renderizar el avatar. { image } si tenemos foto para ese primer nombre; si no,
// { initials }. El componente decide el markup (img vs círculo con iniciales).
//
// La foto se busca SÓLO para alguien del equipo (`team`): el mapa matchea por primer nombre, y en la
// lista de conversaciones también se dibuja el avatar de quien escribió desde la agencia. Sin esa
// guarda, cualquier usuario llamado «Fede» aparecía con la cara de fede.
export function avatarFor(authorName, {team = false} = {}) {
    const first = firstNameOf(authorName);
    // Match case-insensitive por primer nombre contra las claves del mapa.
    const matchKey = team && Object.keys(TEAM_AVATAR_ASSETS).find(
        (key) => key.toLowerCase() === first.toLowerCase(),
    );
    if (matchKey) {
        return {image: TEAM_AVATAR_ASSETS[matchKey], initials: initialsOf(authorName)};
    }
    return {image: null, initials: initialsOf(authorName)};
}

// "{PrimerNombre} · Dashbo" (ej. "Fede · Dashbo"). Si no hay nombre, solo "Dashbo".
export function displayNameFor(authorName) {
    const first = firstNameOf(authorName);
    return first ? `${first} · Dashbo` : 'Dashbo';
}
